import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TrailerTypeRecord {
  id: string;
  kind: string;
  length_ft: number;
  label: string;
  slug: string;
}

export function useTrailerTypes() {
  return useQuery({
    queryKey: ["trailer-types"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("trailer_types")
        .select("id, kind, length_ft, label, slug")
        .order("label");
      if (error) throw error;
      return data as TrailerTypeRecord[];
    },
    staleTime: Infinity, // Lookup table rarely changes
  });
}

/** Get trailer type label by ID from a pre-fetched list */
export function getTrailerTypeLabel(
  trailerTypeId: string | null | undefined,
  trailerTypes: TrailerTypeRecord[] | undefined
): string | null {
  if (!trailerTypeId || !trailerTypes) return null;
  return trailerTypes.find((t) => t.id === trailerTypeId)?.label ?? null;
}
